import { render, staticRenderFns } from "./AddEthicLetter.vue?vue&type=template&id=1abbfd36"
import script from "./AddEthicLetter.vue?vue&type=script&lang=js"
export * from "./AddEthicLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1abbfd36')) {
      api.createRecord('1abbfd36', component.options)
    } else {
      api.reload('1abbfd36', component.options)
    }
    module.hot.accept("./AddEthicLetter.vue?vue&type=template&id=1abbfd36", function () {
      api.rerender('1abbfd36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/dispenseManagement/components/AddEthicLetter.vue"
export default component.exports